import './index-d722456d.js';
import { isProduction } from './constantsIsProduction.js';

const isDevelopment = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'development';
const IS_SSR = typeof window === 'undefined';
const locale = process.env.NEXT_PUBLIC_DEPLOY_LOCALE
    ? process.env.NEXT_PUBLIC_DEPLOY_LOCALE
    : 'vi-VN';
const BEARER_TOKEN_COOKIE = 'hhg_user_token';
const BEARER_ADMIN_TOKEN_COOKIE = 'hhg_admin_token';
const GUEST_CART_ID_COOKIE = 'hhg_guest_cart_id';
const GOOGLE_MAP_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY || '';
const GOOGLE_ADMIN_LOCATION_KEY = process.env.NEXT_PUBLIC_ADMIN_GOOGLE_LOCATION_KEY;
const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ||
    '289442006438-cihobuq1h3r4426pur7u0e43fqdnep59.apps.googleusercontent.com';
const GOOGLE_CALENDAR_API_KEY = '';
const basePath = 'shop';
const SSO_USER_BASE_PATH = 'user';
const CARE_BASE_PATH = 'care';
const COMMUNITY_BASE_PATH = 'community';
const HEALTH_TOOLs_BASE_PATH = 'health-tools';
const NOTIFICATION_TIME_OUT = 3000;
const DOMAIN_LOCALES = {
    'vi-VN': 'hellobacsi.com',
    'id-ID': 'hellosehat.com',
    'ms-MY': 'hellodoktor.com',
    'km-KH': 'hellokrupet.com',
    'en-PH': 'hellodoctor.com.ph',
    'th-TH': 'hellokhunmor.com',
    'my-MM': 'hellosayarwon.com',
    'zh-TW': 'helloyishi.com.tw',
    'hi-IN': 'helloswasthya.com',
};
const DISCOVER_URL_FE = isDevelopment
    ? 'http://localhost:3001'
    : isProduction
        ? `https://${DOMAIN_LOCALES[locale]}`
        : `https://discover.${DOMAIN_LOCALES[locale]}`;
const DISCOVER_URL_BE = isProduction
    ? `https://wp.${DOMAIN_LOCALES[locale]}/`
    : `https://staging.${DOMAIN_LOCALES[locale]}/`;
const TOGETHER_URL_BE = process.env.NEXT_PUBLIC_TOGETHER_API_URL &&
    process.env.NEXT_PUBLIC_TOGETHER_API_URL !== ''
    ? process.env.NEXT_PUBLIC_TOGETHER_API_URL
    : `https://together.${DOMAIN_LOCALES[locale]}/`;
const TOGETHER_URL_FE = `${DISCOVER_URL_FE}/community`;
const SSO_URL = process.env.NEXT_PUBLIC_SSO_URL || 'http://staging-id.hellobacsi.com/';
const DISCOVERY_FOOTER_URL = '#';
const HEALTH_CARE_FOOTER_URL = '#';
const HEALTH_TOOLS_FOOTER_URL = '#';
const HEALTH_TOGETHER_FOOTER_URL = '#';
const POLICIES_FOOTER_URL = '#';
const FAQ_FOOTER_URL = '#';
const SITEMAP_FOOTER_URL = '#';
const ABOUT_US_FOOTER_URL = '#';
const EXECUTIVE_BIOS_FOOTER_URL = '#';
const ADVERTISING_FOOTER_URL = '#';
const CONTACT_US_FOOTER_URL = '#';
const ABOUT_GO_CARE_FOOTER_URL = '#';
var Gender;
(function (Gender) {
    Gender[Gender["FEMALE"] = 0] = "FEMALE";
    Gender[Gender["MALE"] = 1] = "MALE";
    Gender[Gender["ANY"] = 2] = "ANY";
})(Gender || (Gender = {}));
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const COUNTRY_SITENAME = {
    ID: 'Hello Sehat',
    TH: 'Hello Khunmor',
    MY: 'Hello Doktor',
    KH: 'Hello Krupet',
    TW: 'Hello Yishi',
    MM: 'Hello Sayarwon',
    IN: 'Hello Swasthya',
    VN: 'Hello Bacsi',
    PH: 'Hello Doctor',
};
const LOCALE_SPECS = {
    'vi-VN': {
        LOGO_TYPE: 'hellobacsi',
        SITE_NAME: 'HelloBacsi',
        SITE_NAME_FORMATTED: 'Hello Bacsi',
        HOMEPAGE_IMAGE: 'https://hellobacsi.com/images/country-thumbnails/VN.png',
        SITE_ID: '1',
        INSIDER_TAG: '//hellobacsivn.api.useinsider.com/ins.js?id=10003798',
        TOOLTIP_IMAGE: '/images/tooltips-vn.png',
    },
    'en-PH': {
        LOGO_TYPE: 'hellodoctor',
        SITE_NAME: 'HelloDoctor',
        HOMEPAGE_IMAGE: 'https://hellodoctor.com.ph/images/country-thumbnails/PH.png',
        SITE_NAME_FORMATTED: 'Hello Doctor',
        SITE_ID: '9',
        CATEGORIES_TYPE: 'short',
        INSIDER_TAG: '//hellodoctorph.api.useinsider.com/ins.js?id=10004527',
        TOOLTIP_IMAGE: '/images/tooltips-ph.png',
    },
    'th-TH': {
        LOGO_TYPE: 'hellokhunmor',
        SITE_NAME: 'HelloKhunmor',
        HOMEPAGE_IMAGE: 'https://hellokhunmor.com/images/country-thumbnails/TH.png',
        SITE_NAME_FORMATTED: 'Hello Khunmor',
        SITE_ID: '3',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//hellokhunmor.api.useinsider.com/ins.js?id=10004524',
        TOOLTIP_IMAGE: '/images/tooltips-th.png',
    },
    'km-KH': {
        LOGO_TYPE: 'hellokrupet',
        SITE_NAME: 'HelloKrupet',
        HOMEPAGE_IMAGE: 'https://hellokrupet.com/images/country-thumbnails/KH.JPG',
        SITE_NAME_FORMATTED: 'Hello Krupet',
        SITE_ID: '4',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//hellokrupet.api.useinsider.com/ins.js?id=10004523',
        TOOLTIP_IMAGE: '/images/tooltips-kh.png',
    },
    'my-MM': {
        LOGO_TYPE: 'hellosayarwon',
        SITE_NAME: 'HelloSayarwon',
        HOMEPAGE_IMAGE: 'https://hellosayarwon.com/images/country-thumbnails/PH.png',
        SITE_NAME_FORMATTED: 'Hello Sayarwon',
        SITE_ID: '7',
        INSIDER_TAG: '//hellosayarwon.api.useinsider.com/ins.js?id=10004522',
    },
    'zh-TW': {
        LOGO_TYPE: 'helloyishi',
        SITE_NAME: 'HelloYishi',
        HOMEPAGE_IMAGE: 'https://helloyishi.com.tw/images/country-thumbnails/TW.png',
        SITE_NAME_FORMATTED: 'Hello Yishi',
        SITE_ID: '6',
        INSIDER_TAG: '//helloyishi.api.useinsider.com/ins.js?id=10004526',
        TOOLTIP_IMAGE: '/images/tooltips-tw.png',
    },
    'id-ID': {
        LOGO_TYPE: 'hellosehat',
        SITE_NAME: 'HelloSehat',
        HOMEPAGE_IMAGE: 'https://hellosehat.com/images/country-thumbnails/ID.png',
        SITE_NAME_FORMATTED: 'Hello Sehat',
        SITE_ID: '2',
        INSIDER_TAG: '//hellosehat.api.useinsider.com/ins.js?id=10003799',
        TOOLTIP_IMAGE: '/images/tooltips-id.png',
    },
    'hi-IN': {
        LOGO_TYPE: 'helloswasthya',
        SITE_NAME: 'HelloSwasthya',
        HOMEPAGE_IMAGE: 'https://helloswasthya.com/images/country-thumbnails/IN.png',
        SITE_NAME_FORMATTED: 'हैलो स्वास्थ्य',
        SITE_ID: '8',
        CATEGORIES_TYPE: 'long',
        INSIDER_TAG: '//helloswasthya.api.useinsider.com/ins.js?id=10004498',
        TOOLTIP_IMAGE: '/images/tooltips-in.png',
    },
    'ms-MY': {
        LOGO_TYPE: 'hellodoktor',
        SITE_NAME: 'HelloDoktor',
        HOMEPAGE_IMAGE: 'https://hellodoktor.com/images/country-thumbnails/MY.png',
        SITE_NAME_FORMATTED: 'Hello Doktor',
        SITE_ID: '5',
        INSIDER_TAG: '//hellodoktor.api.useinsider.com/ins.js?id=10004525',
        TOOLTIP_IMAGE: '/images/tooltips-my.png',
    },
};
const SOCIAL_MEDIA = {
    'vi-VN': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/hellobacsi/',
        INSTAGRAM: 'https://www.instagram.com/hellobacsi/',
        TWITTER: null,
        YOUTUBE: 'https://www.youtube.com/channel/UCYHzHDXngnB7jkmcQgXwE0w',
    },
    'en-PH': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/HelloDoctorPH/',
        INSTAGRAM: 'https://www.instagram.com/hellodoctor_ph/',
        TWITTER: null,
    },
    'km-KH': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/hellokrupet/',
        INSTAGRAM: 'https://www.instagram.com/hellokrupetofficial/',
        TWITTER: null,
        YOUTUBE: 'https://www.youtube.com/channel/UCVK4p9YPIMkmoerk3X-y-TQ',
    },
    'ms-MY': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/HelloDoktorMY/',
        INSTAGRAM: 'https://www.instagram.com/_hellodoktor_/',
        TWITTER: null,
    },
    'id-ID': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-sehat/',
        FACEBOOK: 'https://www.facebook.com/hellosehat',
        INSTAGRAM: 'https://www.instagram.com/hellosehat/',
        TWITTER: 'https://twitter.com/HelloSehat',
    },
    'my-MM': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/hellosayarwon/',
        INSTAGRAM: 'https://www.facebook.com/hellosayarwon/',
        TWITTER: null,
    },
    'zh-TW': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/helloyishi/',
        INSTAGRAM: 'https://www.instagram.com/helloyishi/',
        TWITTER: null,
    },
    'hi-IN': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/HelloSwasthya/',
        INSTAGRAM: 'https://www.instagram.com/hello_swasthya/',
        TWITTER: null,
    },
    'th-TH': {
        LINKEDIN: 'https://www.linkedin.com/company/hello-health-group/',
        FACEBOOK: 'https://www.facebook.com/hellokhunmor/',
        INSTAGRAM: 'https://www.instagram.com/hellokhunmor/',
        TWITTER: null,
        YOUTUBE: 'https://www.youtube.com/channel/UCbdbow4UhKfa7rqIhclNPIQ/',
    },
};
const FLAG_LINKS = {
    ID: 'https://hellosehat.com/',
    TH: 'https://hellokhunmor.com/',
    MY: 'https://hellodoktor.com/',
    KH: 'https://hellokrupet.com/',
    TW: 'https://helloyishi.com.tw/',
    MM: 'https://hellosayarwon.com/',
    IN: 'https://helloswasthya.com/',
    VN: 'https://hellobacsi.com/',
    PH: 'https://hellodoctor.com.ph/',
};
const STATIC_PAGES = {
    'vi-VN': {
        PRIVACY: '/privacy',
        TERM_OF_USE: '/dieu-khoan-su-dung',
        PRIVACY_POLICY: '/chinh-sach-quyen-rieng-tu',
        EDITORIAL_CORRECTIONS_POLICY: '/chinh-sach-bien-tap-chinh-sua',
        ADVERTISING_SPONSOR_POLICY: '/chinh-sach-quang-cao-tai-tro',
        POLICIES: '/chinh-sach',
        FAQS: '/thong-tin-quan-trong',
        SITEMAP: '/sitemap',
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/quang-cao-voi-chung-toi',
        CONTACT_US: '/lien-he',
        ABOUT_GO_CARE: '/about-go-care',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/hello-bacsi/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'km-KH': {
        POLICIES: '/policies',
        TERM_OF_USE: '/ខនិងលក្ខខណ្ឌ',
        PRIVACY_POLICY: '/គោលការណ៍ឯកជនភាព',
        EDITORIAL_CORRECTIONS_POLICY: '/គោលការណ៍ខ្លឹមសារមាតិកា',
        ADVERTISING_SPONSOR_POLICY: '/គោលការណ៍ផ្សាយពាណិជ្ជកម',
        FAQS: '/faqs',
        SITEMAP: '/sitemap',
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/advertisement',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: '/about-go-care',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: '/#',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'en-PH': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'my-MM': {
        POLICIES: '/polisi-terma-syarat',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/pengiklanan',
        CONTACT_US: '/hubungi-kami',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: ' https://hellohealthgroup.com/hello-doktor/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'zh-TW': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/advertising',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        FACILITY: '/facility',
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'id-ID': {
        POLICIES_EN: '/policies',
        TERM_OF_USE: '/kebijakan-pengguna',
        PRIVACY_POLICY: '/kebijakan-privasi',
        EDITORIAL_CORRECTIONS_POLICY: '/kebijakan-editorial',
        ADVERTISING_SPONSOR_POLICY: '/kebijakan-iklan',
        POLICIES: '/kebijakan',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/kontak-kami',
        CONTACT_EN: '/contact',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/hello-sehat/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
        EDITORIAL_POLICY: '/edit-id',
        EDITORIAL_POLICY_EN: '/edit-en',
    },
    'hi-IN': {
        POLICIES: '/policies',
        TERM_OF_USE: '/terms-of-use',
        PRIVACY_POLICY: '/privacy-policy',
        EDITORIAL_CORRECTIONS_POLICY: '/editorial-and-corrections-policy',
        ADVERTISING_SPONSOR_POLICY: '/advertising-and-sponsor-policy',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: null,
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'ms-MY': {
        POLICIES: '/polisi-terma-syarat',
        TERM_OF_USE: '/terma-dan-syarat',
        PRIVACY_POLICY: '/polisi-privasi',
        EDITORIAL_CORRECTIONS_POLICY: '/polisi-editorial',
        ADVERTISING_SPONSOR_POLICY: '/polisi-pengiklanan',
        FAQS: null,
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/pengiklanan',
        CONTACT_US: '/hubungi-kami',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: ' https://hellohealthgroup.com/hello-doktor/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
    'th-TH': {
        POLICIES_EN: '/policies',
        TERM_OF_USE: '/เงื่อนใขการใช้งาน',
        PRIVACY_POLICY: '/นโยบายความเป็นส่วนตัว',
        EDITORIAL_CORRECTIONS_POLICY: '/นโยบายบรรณธิการ',
        ADVERTISING_SPONSOR_POLICY: '/นโยบายการโฆษณาและผู้สนับสนุน',
        POLICIES: '/นโยบาย',
        FAQS: '/คำถามที่พบบ่อย',
        SITEMAP: null,
        ABOUT_US: '/about-us',
        ADVERTISEMENT: '/ลงโฆษณากับเรา',
        CONTACT_US: '/contact-us',
        ABOUT_GO_CARE: null,
        HEALTH_TOOLS: '/health-tools',
        EXECUTIVE_BIOS: 'https://hellohealthgroup.com/management-team/',
        RECRUITMENT: 'https://hellohealthgroup.com/careers/',
    },
};
const FAVICONS = {
    'vi-VN': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'km-KH': [
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/km-KH/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/km-KH/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/km-KH/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/km-KH/icon-270x270.png',
        },
    ],
    'en-PH': [
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/en-PH/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/en-PH/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon',
            href: '/by-locales/en-PH/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/en-PH/icon-270x270.png',
        },
    ],
    'id-ID': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'ms-MY': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'th-TH': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'my-MM': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'zh-TW': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
    'hi-IN': [
        {
            type: 'link',
            rel: 'shortcut icon',
            href: '/by-locales/vi-VN/favicon.ico',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-32x32.png',
            sizes: '32x32',
        },
        {
            type: 'link',
            rel: 'icon',
            href: '/by-locales/vi-VN/icon-192x192.png',
            sizes: '192x192',
        },
        {
            type: 'link',
            rel: 'apple-touch-icon-precomposed',
            href: '/by-locales/vi-VN/icon-180x180.png',
        },
        {
            type: 'meta',
            name: 'msapplication-TileImage',
            content: '/by-locales/vi-VN/icon-270x270.png',
        },
    ],
};
const LOCALE_COUNTRY = {
    'vi-VN': { id: 1, name: 'Vietnam' },
    'id-ID': { id: 2, name: 'Indonesia' },
    'ms-MY': { id: 3, name: 'Malaysia' },
    'km-KH': { id: 4, name: 'Cambodia' },
    'en-PH': { id: 5, name: 'Philippines' },
    'th-TH': { id: 6, name: 'Thai Lan' },
    'my-MM': { id: 7, name: 'Myanmar' },
    'zh-TW': { id: 8, name: 'Taiwan' },
    'hi-IN': { id: 9, name: 'India' },
};
const MAX_ALLOWED_IMG_SIZE = 20 * 1024 * 1024;
const COUNTRY_CODE_BY_LOCALE = {
    'vi-VN': 'vn',
    'id-ID': 'id',
    'ms-MY': 'my',
    'km-KH': 'kh',
    'en-PH': 'ph',
    'th-TH': 'th',
    'my-MM': 'mm',
    'zh-TW': 'tw',
    'hi-IN': 'in',
};
const COUNTRY_CURRENCY_SYMBOL = {
    'vi-VN': '₫',
    'id-ID': 'Rp',
    'ms-MY': 'RM',
    'km-KH': '៛',
    'en-PH': '₱',
    'th-TH': '฿',
    'my-MM': 'K',
    'zh-TW': '$',
    'hi-IN': '₹',
};
const CURRENCY_PREFIX = {
    IDR: 'Dimulai dari', // Dimulai dari IDR 800,000
};
const LOCALISED_SLUGS = {
    'en-PH': {
        PRODUCT: 'product',
        CATEGORY: 'category',
        BRAND: 'brand',
        SEARCH: 'search',
        PROFILE: 'profile',
        PROFILE_MANAGE_ORDERS: 'profile/manage-orders',
        PROFILE_MANAGE_ADDRESS: 'profile/deliver-address',
        PROFILE_VOUCHER: 'profile/voucher',
        PROFILE_MEMBER_CARD: 'profile/member-card',
        CART: 'cart',
        CART_CHECKOUT: 'cart/checkout',
        ORDER_CONFIRMATION: 'order-confirmation',
        PROMOTION: 'promotion',
    },
    'vi-VN': {
        PRODUCT: 'san-pham',
        CATEGORY: 'danh-muc',
        BRAND: 'thuong-hieu',
        SEARCH: 'tim-kiem',
        PROFILE: 'ho-so',
        PROFILE_MANAGE_ORDERS: 'ho-so/quan-li-don-hang',
        PROFILE_MANAGE_ADDRESS: 'ho-so/dia-chi-giao-hang',
        PROFILE_VOUCHER: 'ho-so/khuyen-mai',
        PROFILE_MEMBER_CARD: 'ho-so/the-thanh-vien',
        CART: 'gio-hang',
        CART_CHECKOUT: 'gio-hang/thanh-toan',
        ORDER_CONFIRMATION: 'kiem-tra-don-hang',
        PROMOTION: 'khuyen-mai',
    },
};
const HEADER_LOGO_ALIGNMENT = '188px';
const globalFontFamily = 'Inter';
const ENABLE_COMMUNITY_LOCALES = [
    'vi-VN',
    'id-ID',
    'ms-MY',
    'en-PH',
    'th-TH',
];
const ENABLE_HEALTH_PARENTING_LOCALES = [
    'vi-VN',
    'en-PH',
    'id-ID',
    'ms-MY',
    'km-KH',
    'th-TH',
    'my-MM',
    'zh-TW',
];
const SEO_SCHEMA = {
    'vi-VN': {
        HOME: () => JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@id': 'https://hellobacsi.com/shop/#website',
                    '@type': 'WebSite',
                    description: 'Hello Bacsi - Health Information',
                    inLanguage: 'vi-VN',
                    name: 'Hello Bacsi',
                    potentialAction: [
                        {
                            '@type': 'SearchAction',
                            'query-input': 'required name=search_term_string',
                            target: 'https://hellobacsi.com/shop/tim-kiem/?keyword={search_term_string}',
                        },
                    ],
                    url: 'https://hellobacsi.com/shop/',
                },
            ],
        }),
        CATEGORY: (urlWithParams = '', itemCount = 0, itemList = []) => JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@id': 'https://hellobacsi.com/shop/#breadcrumb',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        {
                            '@type': 'ListItem',
                            item: {
                                '@id': 'https://hellobacsi.com/shop/',
                                '@type': 'WebPage',
                                name: 'Hello Bacsi',
                                url: 'https://hellobacsi.com/shop/',
                            },
                        },
                        {
                            '@type': 'ListItem',
                            item: {
                                '@id': 'https://hellobacsi.com/shop/danh-muc',
                                '@type': 'WebPage',
                                name: 'Hello Bacsi - Danh Muc',
                                url: 'https://hellobacsi.com/shop/danh-muc',
                            },
                        },
                    ],
                },
                {
                    '@type': 'ItemList',
                    url: urlWithParams,
                    numberOfItems: itemCount,
                    itemListElement: itemList,
                },
            ],
        }),
        BRAND: (urlWithParams = '', itemCount = 0, itemList = []) => JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@id': 'https://hellobacsi.com/shop/#breadcrumb',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        {
                            '@type': 'ListItem',
                            item: {
                                '@id': 'https://hellobacsi.com/shop/',
                                '@type': 'WebPage',
                                name: 'Hello Bacsi',
                                url: 'https://hellobacsi.com/shop/',
                            },
                        },
                        {
                            '@type': 'ListItem',
                            item: {
                                '@id': 'https://hellobacsi.com/shop/thuong-hieu',
                                '@type': 'WebPage',
                                name: 'Hello Bacsi - Thuong Hieu',
                                url: 'https://hellobacsi.com/shop/thuong-hieu',
                            },
                        },
                    ],
                },
                {
                    '@type': 'ItemList',
                    url: urlWithParams,
                    numberOfItems: itemCount,
                    itemListElement: itemList,
                },
            ],
        }),
        BRAND_DETAIL: (urlWithParams = '', itemCount = 0, itemList) => JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@id': 'https://hellobacsi.com/shop/thuong-hieu/#brand',
                    '@type': 'BrandDetail',
                    itemListElement: [
                        {
                            '@type': 'Item',
                            item: {
                                '@id': `https://hellobacsi.com/shop${urlWithParams}`,
                                '@type': 'WebPage',
                                name: 'Hello Bacsi - Thuong Hieu',
                                url: `https://hellobacsi.com/shop${urlWithParams}`,
                            },
                        },
                    ],
                },
                {
                    '@type': 'BrandDetail',
                    url: `https://hellobacsi.com/shop${urlWithParams}`,
                    numberOfItems: itemCount,
                    itemListElement: itemList !== null && itemList !== void 0 ? itemList : {},
                },
            ],
        }),
        PRODUCT_DETAIL: (urlWithParams = '', itemCount = 0, itemList) => JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
                {
                    '@id': 'https://hellobacsi.com/shop/san-pham/#product',
                    '@type': 'ProductDetail',
                    itemListElement: [
                        {
                            '@type': 'Item',
                            item: {
                                '@id': `https://hellobacsi.com/shop/san-pham/${urlWithParams}`,
                                '@type': 'WebPage',
                                name: 'Hello Bacsi - Thuong Hieu',
                                url: `https://hellobacsi.com/shop/san-pham/${urlWithParams}`,
                            },
                        },
                    ],
                },
                {
                    '@type': 'BrandDetail',
                    url: urlWithParams,
                    numberOfItems: itemCount,
                    itemListElement: itemList !== null && itemList !== void 0 ? itemList : {},
                },
            ],
        }),
    },
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isDevelopment: isDevelopment,
  IS_SSR: IS_SSR,
  locale: locale,
  BEARER_TOKEN_COOKIE: BEARER_TOKEN_COOKIE,
  BEARER_ADMIN_TOKEN_COOKIE: BEARER_ADMIN_TOKEN_COOKIE,
  GUEST_CART_ID_COOKIE: GUEST_CART_ID_COOKIE,
  GOOGLE_MAP_KEY: GOOGLE_MAP_KEY,
  GOOGLE_ADMIN_LOCATION_KEY: GOOGLE_ADMIN_LOCATION_KEY,
  GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
  GOOGLE_CALENDAR_API_KEY: GOOGLE_CALENDAR_API_KEY,
  basePath: basePath,
  SSO_USER_BASE_PATH: SSO_USER_BASE_PATH,
  CARE_BASE_PATH: CARE_BASE_PATH,
  COMMUNITY_BASE_PATH: COMMUNITY_BASE_PATH,
  HEALTH_TOOLs_BASE_PATH: HEALTH_TOOLs_BASE_PATH,
  NOTIFICATION_TIME_OUT: NOTIFICATION_TIME_OUT,
  DOMAIN_LOCALES: DOMAIN_LOCALES,
  DISCOVER_URL_FE: DISCOVER_URL_FE,
  DISCOVER_URL_BE: DISCOVER_URL_BE,
  TOGETHER_URL_BE: TOGETHER_URL_BE,
  TOGETHER_URL_FE: TOGETHER_URL_FE,
  SSO_URL: SSO_URL,
  DISCOVERY_FOOTER_URL: DISCOVERY_FOOTER_URL,
  HEALTH_CARE_FOOTER_URL: HEALTH_CARE_FOOTER_URL,
  HEALTH_TOOLS_FOOTER_URL: HEALTH_TOOLS_FOOTER_URL,
  HEALTH_TOGETHER_FOOTER_URL: HEALTH_TOGETHER_FOOTER_URL,
  POLICIES_FOOTER_URL: POLICIES_FOOTER_URL,
  FAQ_FOOTER_URL: FAQ_FOOTER_URL,
  SITEMAP_FOOTER_URL: SITEMAP_FOOTER_URL,
  ABOUT_US_FOOTER_URL: ABOUT_US_FOOTER_URL,
  EXECUTIVE_BIOS_FOOTER_URL: EXECUTIVE_BIOS_FOOTER_URL,
  ADVERTISING_FOOTER_URL: ADVERTISING_FOOTER_URL,
  CONTACT_US_FOOTER_URL: CONTACT_US_FOOTER_URL,
  ABOUT_GO_CARE_FOOTER_URL: ABOUT_GO_CARE_FOOTER_URL,
  get Gender () { return Gender; },
  EMAIL_REGEX: EMAIL_REGEX,
  COUNTRY_SITENAME: COUNTRY_SITENAME,
  LOCALE_SPECS: LOCALE_SPECS,
  SOCIAL_MEDIA: SOCIAL_MEDIA,
  FLAG_LINKS: FLAG_LINKS,
  STATIC_PAGES: STATIC_PAGES,
  FAVICONS: FAVICONS,
  LOCALE_COUNTRY: LOCALE_COUNTRY,
  MAX_ALLOWED_IMG_SIZE: MAX_ALLOWED_IMG_SIZE,
  COUNTRY_CODE_BY_LOCALE: COUNTRY_CODE_BY_LOCALE,
  COUNTRY_CURRENCY_SYMBOL: COUNTRY_CURRENCY_SYMBOL,
  CURRENCY_PREFIX: CURRENCY_PREFIX,
  LOCALISED_SLUGS: LOCALISED_SLUGS,
  HEADER_LOGO_ALIGNMENT: HEADER_LOGO_ALIGNMENT,
  globalFontFamily: globalFontFamily,
  ENABLE_COMMUNITY_LOCALES: ENABLE_COMMUNITY_LOCALES,
  ENABLE_HEALTH_PARENTING_LOCALES: ENABLE_HEALTH_PARENTING_LOCALES,
  SEO_SCHEMA: SEO_SCHEMA
});

export { LOCALISED_SLUGS as L, constants as c };
